<!--
  LanguageSelector.svelte — the flag button that switches the interface language.

  Deliberately **not** `AbstractDropdown`/`SelectField`: this is a compact menu in the navbar (and
  on the public sign-in pages) whose trigger is a flag alone, and every row names its own language
  in that language — there is nothing a second descriptive line would add. Binds to the i18n locale
  store.
-->
<script lang="ts">
	import { Button, Dropdown, DropdownItem, Img } from 'flowbite-svelte';
	import { locale, locales, localeFlags, localeNames } from '../i18n';

	let { class: className = '', buttonClass = '' }: { class?: string; buttonClass?: string } = $props();

	/** Whether the menu is showing. */
	let isOpen = $state(false);

	/** Resolve a locale code to its flag SVG path. */
	function flagSrc(loc: string): string {
		return `/flags/${localeFlags[loc] || loc}.svg`;
	}

	/** Switches the interface language and closes the menu. */
	function select(loc: string): void {
		locale.set(loc);
		isOpen = false;
	}
</script>

<div class="relative {className}">
	<Button color="alternative" class="w-full justify-between {buttonClass}" aria-label={localeNames[$locale] ?? $locale}>
		<Img class="rounded-sm" src={flagSrc($locale)} />
		<i class="fa-solid fa-chevron-down ms-2 h-3 w-3 shrink-0"></i>
	</Button>
	<Dropdown simple bind:isOpen triggerDelay={0} transitionParams={{ duration: 0 }}>
		{#each locales as loc (loc)}
			<DropdownItem onclick={() => select(loc)}>
				<Img class="rounded-sm" src={flagSrc(loc)} />
			</DropdownItem>
		{/each}
	</Dropdown>
</div>
